import PropTypes from "prop-types"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"

const texts = {
  pt: [
    "Promovendo o compartilhamento de dados e ferramentas de análise de dados",
    <>
      CAMARADES BR nasceu da parceria entre cientistas de vários locais do mundo
      com o apoio do <span className="fw-bold">Prof Dr Malcolm Macleod</span>{" "}
      fundador do grupo <span className="fw-bold">CAMARADES</span>. O site
      CAMARADES BR foi criado em 2022 como resultado de um projeto de Cooperação
      Digital entre Brasil e Alemanha financiado pela{" "}
      <span className="fw-bold">Fundação Alexander von Humboldt</span>.
    </>,
    <>
      O projeto de cooperação foi coordenado pela{" "}
      <span className="fw-bold">Prof Dr Cilene Lino de Oliveira</span>{" "}
      (Universidade Federal de Santa Catarina, Brasil) e pelas doutoras{" "}
      <span className="fw-bold">Alexandra Bannach-Brown</span> e{" "}
      <span className="fw-bold">Sarah McCann</span>, fundadoras do CAMARADES
      Berlim.
    </>,
    <>
      A manutenção e administração do site Camarades Brasil é de responsabilidade
      do{" "}
      <a
        href="https://labnec.ccb.ufsc.br/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Labnec-CFS-CCB-UFSC
      </a>{" "}
      da Universidade Federal de Santa Catarina.
    </>,
    "Conheça o nosso Time Fundador",
    "UFSC, Brasil",
    "CAMARADES Berlim",
  ],
  en: [
    "Promoting data sharing and data analysis tools",
    <>
      CAMARADES BR was born from a partnership between scientists from different
      parts of the world with the support of{" "}
      <span className="fw-bold">Prof Dr Malcolm Macleod</span> found of the{" "}
      <span className="fw-bold">CAMARADES</span> group. The CAMARADES BR website
      was created in 2022 due to a Digital Cooperation project between Brazil
      and Germany financed by the{" "}
      <span className="fw-bold">Alexander von Humboldt Foundation</span>.
    </>,
    <>
      The cooperation project was coordinated by{" "}
      <span className="fw-bold">Prof Dr Cilene Lino de Oliveira</span>{" "}
      (Universidade Federal de Santa Catarina - Federal University of Santa
      Catarina, Brazil) and by PhDs{" "}
      <span className="fw-bold">Alexandra Bannach-Brown</span> and{" "}
      <span className="fw-bold">Sarah McCann</span>, founders of CAMARADES
      Berlin.
    </>,
    <>
      The maintenance and administration of the Camarades Brazil website is the
      responsibility of{" "}
      <a
        href="https://labnec.ccb.ufsc.br/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Labnec-CFS-CCB-UFSC
      </a>{" "}
      at Universidade Federal de Santa Catarina.
    </>,
    "Meet our Founding Team",
    "UFSC, Brazil",
    "CAMARADES Berlin",
  ],
}

function Founders({ language }) {
  const text = texts[language]

  return (
    <section className="clg">
      <div className="row">
        <h2 className="col-md-6 col-sm-12">{text[0]}</h2>
      </div>
      <div className="row">
        <div className="col-md-4 col-sm-6">
          <p>{text[1]}</p>
        </div>
        <div className="col-md-4 col-sm-6">
          <p>
            {text[2]}
            <br />
            <br />
            {text[3]}
          </p>
        </div>
      </div>
      <div className="row pt-5">
        <div className="col-12">
          <h3>{text[4]}</h3>
        </div>
        <div className="col-12 row d-flex justify-content-evenly">
          <div className="col-lg-3 col-sm-6 row d-flex staff">
            <div className="col">
              <StaticImage
                src="../../../assets/images/staff/pdmm.png"
                alt="pdmm"
              />
            </div>
            <div className="col">
              <a
                className="text-decoration-none"
                href="https://orcid.org/0000-0001-9187-9839"
                target="_blank"
                rel="noopener noreferrer"
              >
                <StaticImage
                  src="../../../assets/images/icons/orcid.png"
                  alt="orcid"
                />
              </a>
              <br />
              <span>Prof Dr Malcolm Macleod</span>
              <br />
              <a
                className="text-decoration-none"
                href="https://www.ed.ac.uk/clinical-brain-sciences/research/camarades/about-camarades"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="fw-bold">CAMARADES</span>
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 row d-flex staff">
            <div className="col">
              <StaticImage
                src="../../../assets/images/staff/pdco.png"
                alt="pdco"
              />
            </div>
            <div className="col">
              <a
                className="text-decoration-none"
                href="https://orcid.org/0000-0002-0627-530X"
                target="_blank"
                rel="noopener noreferrer"
              >
                <StaticImage
                  src="../../../assets/images/icons/orcid.png"
                  alt="orcid"
                />
              </a>
              <br />
              <span>Prof Dr Cilene Lino de Oliveira</span>
              <br />
              <a
                className="text-decoration-none"
                href="https://ufsc.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="fw-bold">{text[5]}</span>
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 row d-flex staff">
            <div className="col">
              <StaticImage
                src="../../../assets/images/staff/abb.png"
                alt="abb"
              />
            </div>
            <div className="col">
              <a
                className="text-decoration-none"
                href="https://orcid.org/0000-0002-3161-1395"
                target="_blank"
                rel="noopener noreferrer"
              >
                <StaticImage
                  src="../../../assets/images/icons/orcid.png"
                  alt="orcid"
                />
              </a>
              <br />
              <span>Alexandra Bannach-Brown</span>
              <br />
              <a
                className="text-decoration-none"
                href="https://www.bihealth.org/en/translation/innovation-enabler/quest-center/service/camarades"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="fw-bold">{text[6]}</span>
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 row d-flex staff">
            <div className="col">
              <StaticImage src="../../../assets/images/staff/sm.png" alt="sm" />
            </div>
            <div className="col">
              <a
                className="text-decoration-none"
                href="https://orcid.org/0000-0003-4737-2349"
                target="_blank"
                rel="noopener noreferrer"
              >
                <StaticImage
                  src="../../../assets/images/icons/orcid.png"
                  alt="orcid"
                />
              </a>
              <br />
              <span>Sarah McCann</span>
              <br />
              <a
                className="text-decoration-none"
                href="https://www.bihealth.org/en/translation/innovation-enabler/quest-center/service/camarades"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="fw-bold">{text[6]}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

Founders.propTypes = {
  language: PropTypes.oneOf(["pt", "en"]),
}

export default Founders
